import React, { useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { DropdownFieldWUT } from '../../../ui/dropdown-field';
export const DropdownWUT = ({ options, ...rest })=>{
    const fieldType = FIELD_TYPES.DROPDOWN;
    const dropdownOptions = useMemo(()=>(options || []).map((option)=>({
                label: option.label,
                value: option.value ?? option.label
            })), [
        options
    ]);
    return /*#__PURE__*/ React.createElement(DropdownFieldWUT, {
        ...rest,
        fieldType: fieldType,
        options: dropdownOptions
    });
};

//# sourceMappingURL=dropdown-wut.js.map